

import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAYzoT7Gmkd853xwGX16tUQhlkdIrKvHUs",
  authDomain: "photo-gallery-68f56.firebaseapp.com",
  projectId: "photo-gallery-68f56",
  storageBucket: "photo-gallery-68f56.firebasestorage.app",
  messagingSenderId: "360109720638",
  appId: "1:360109720638:web:17143a0ab7ad444428fd6f"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
